<template>
  <div class="is-flex is-flex-direction-column is-align-items-end">
    <div class="my-1">
      <Checkbox :checked="data.isPhoneCheck" :value="data.isPhoneCheck" @input="(e) => { data.isPhoneCheck = e; validate() }">מעבר על טלפון</Checkbox>
    </div>
    <div class="my-1">
      <Checkbox :checked="data.isWhatsappCheck" :value="data.isWhatsappCheck" @input="(e) => { data.isWhatsappCheck = e; validate() }">מעבר על וואטסאפ</Checkbox>
    </div>
    <div class="my-1">
      <Checkbox :checked="data.isEmailCheck" :value="data.isEmailCheck" @input="(e) => { data.isEmailCheck = e; validate() }">מייל</Checkbox>
    </div>
    <div class="my-1">
      <Checkbox v-if="isAdmin" :checked="data.isNewLeads" :value="data.isNewLeads" @input="(e) => { data.isNewLeads = e; validate() }">
        <router-link class="has-text-info has-text-right" :to="{ name: 'admin-alerts', query: { statuses: 'active', designators: 'new_lead', past: 'true', sort: '-priority' }}">מעבר על פניות מהאתר
        </router-link>
      </Checkbox>
    </div>
    <div class="my-1">
      <Checkbox :checked="data.isPersonalTaskCheck" :value="data.isPersonalTaskCheck" @input="(e) => { data.isPersonalTaskCheck = e; validate() }">
        <router-link class="has-text-info has-text-right" :to="{ name: 'admin-offers', query: { owner: this.$utils.getOwner().name, statuses: this.getAdvancedStatuses, sort: '-sent_at' }}">מעבר על תהליכים אישיים ומועמדים אישיים
        </router-link>
      </Checkbox>
    </div>
    <div class="my-1">
      <Checkbox v-if="isAdmin" :checked="data.isUniqueCheck" :value="data.isUniqueCheck" @input="(e) => { data.isUniqueCheck = e; validate() }">
        <router-link class="has-text-info has-text-right" :to="{ name: 'admin-alerts', query: { statuses: 'active', designators: getDesignatorsByGroupName('designated_position'), past: 'true', sort: '-priority' } }">מעבר על משרות ייעודיות/ עדכון והוספה
        </router-link>
      </Checkbox>
    </div>
    <div class="my-1">
      <Checkbox v-if="isAdmin" :checked="data.isLeads" :value="data.isLeads" @input="(e) => { data.isLeads = e; validate() }">
        <router-link class="has-text-info has-text-right" :to="{ name: 'admin-alerts', query: { statuses: 'interview,received_proposal', sort: '-sent_at' } }">מעבר על לידים מתקדמים מאוד
        </router-link>
      </Checkbox>
    </div>
    <div class="my-1">
      <Checkbox v-if="isAdmin" :checked="data.isAddUniqueCheck" :value="data.isAddUniqueCheck" @input="(e) => { data.isAddUniqueCheck = e; validate() }">
        <router-link class="has-text-info has-text-right" :to="{ name: 'admin' }" >הוספת משימות ייחודיות (טקסט חופשי/ איתור מעסיקים)
        </router-link>
      </Checkbox>
    </div>
    <div class="my-1">
      <Checkbox v-if="isAdmin" :checked="data.isParallelCheck" :value="data.isParallelCheck" @input="(e) => { data.isParallelCheck = e; validate() }">
        <a class="has-text-info has-text-right">משימות חפיפה (אם קיימת)</a>
      </Checkbox>
    </div>
    <div class="my-1">
      <Checkbox v-if="isSenior" :checked="data.isRegisterPageCheck" :value="data.isRegisterPageCheck" @input="(e) => { data.isRegisterPageCheck = e; validate() }">
        <router-link class="has-text-info has-text-right" :to="{ name: 'admin-alerts', query: { statuses: 'active', designators: getDesignatorsByGroupName('new_registration'), past: 'true', sort: '-priority' } }">מעבר על עמוד הרשמות חדשות
        </router-link>
      </Checkbox>
    </div>
    <div class="m-1">
      <Checkbox v-if="isSenior" :checked="data.isNightOffersCheck" :value="data.isNightOffersCheck" @input="(e) => { data.isNightOffersCheck = e; validate() }">
        <router-link class="has-text-info has-text-right" :to="{ name: 'admin-alerts', query: { statuses: 'active', designators: getDesignatorsByGroupName('vetted_offers'), past: 'true', sort: '-priority' } }">מעבר מהיר על אופרס מהלילה
        </router-link>
      </Checkbox>
    </div>
    <div class="m-1">
      <Checkbox v-if="isRoot " :checked="data.isMyApplicants" :value="data.isMyApplicants" @input="(e) => { data.isMyApplicants = e; validate() }">
        <router-link class="has-text-info has-text-right" :to="{ name: 'admin-applicants', query: { owner: $utils.getOwner().name } }">המועמדים שלי
        </router-link>
      </Checkbox>
    </div>
     <div class="m-1">
      <Checkbox v-if="isRoot" :checked="data.isMyApplicantsSend" :value="data.isMyApplicantsSend" @input="(e) => { data.isMyApplicantsSend = e; validate() }">
        <router-link class="has-text-info has-text-right" :to="{ name: 'admin-offers', query: { statuses: 'awaiting_company_sent', owner: $utils.getOwner().name, sort: '-sent_at' } }">מועמדים שלי ב sent
        </router-link>
      </Checkbox>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Checkbox from './Checkbox.vue'

export default {
  name: 'FeedContentMorningRoutine',
  components: {
    Checkbox
  },
  data () {
    const permisionLevel = this.$utils.getOwner().permission_level
    const admin = [8].includes(permisionLevel)
    const senior = [6, 7].includes(permisionLevel)
    const root = [1, 2, 3, 4, 5, 6].includes(permisionLevel)
    return {
      isAdmin: admin,
      isSenior: senior,
      isRoot: root,
      data: {
        isPhoneCheck: false,
        isWhatsappCheck: false,
        isEmailCheck: false,
        isPersonalTaskCheck: false,
        isUniqueCheck: !admin,
        isAddUniqueCheck: !admin,
        isParallelCheck: !admin,
        isNewLeads: !admin,
        isLeads: !admin,
        isRegisterPageCheck: !senior,
        isNightOffersCheck: !senior,
        isMyApplicants: !root,
        isMyApplicantsSend: !root
      }
    }
  },
  computed: {
    ...mapGetters('feedDesignators', ['feedDesignators']),
    ...mapGetters('offerStatuses', ['getAdvancedStatuses'])
  },
  methods: {
    validate () {
      const isValid = Object.entries(this.data).reduce((prev, [k, v]) => {
        return prev && v
      }, true)
      this.$emit('input', isValid)
    },
    getDesignatorsByGroupName (groupName) {
      const [ group ] = this.feedDesignators.filter(designator => designator.group == groupName)
      if (group) return group.designators.join(',')
      return ''
    }
  }
}
</script>
